import React, { useState } from "react";
import { useForm } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import SelectDropDown from "../common/ReactHookForm/SelectDropDown";
import "./createBatch.css";
import useMutateCreateBatch from "../Hooks/QC/useMutateCreateBatch";
import Spinner from "../common/Spinner";

const CreateBatch = () => {

    const PlateType = ['Fluver', 'DyeCal'];

    const DGMethod = ['Chip Shop', 'Weidmann v5', 'ThinXXS v2a', 'ThinXXS v2b', 'ThinXXS v2c', 'ThinXXS v2c Dimpled'];

    const { register, handleSubmit, reset, setError, clearErrors, formState, errors } = useForm();
    const [startDate, setStartDate] = useState(new Date());
    const createBatchMutation = useMutateCreateBatch();
    const onSubmit = async (data) => {
        //data.CreationDate = startDate;
        if (startDate) {
            clearErrors("CreationDate");
        } else {
            setError("CreationDate", {
                type: "manual",
                message: "Date is required"
            });
            return;
        }

        // Format startDate to 'YYYYMMDD'
        const year = startDate.getFullYear();
        const month = String(startDate.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JS
        const day = String(startDate.getDate()).padStart(2, '0');
        data.CreationDate = `${year}${month}${day}`;
        data.Quantity = parseInt(data.Quantity, 10);

        // Map form field names to API field names
        const apiData = {
            name: data.Name,
            plate_type: data["Plate Type"],
            creation_date: data.CreationDate,
            dg_method: data["DG Method"],
            maker: data.Maker,
            quantity: data.Quantity,
            fam_hi_size: data["FAM HI Size (μm)"],
            vic_hi_size: data["VIC HI Size (μm)"],
            hex_hi_size: data["HEX HI Size (μm)"],
            notes: data.Notes,
        };
        createBatchMutation.mutate({ apiData },
            {
                onSuccess: (response) => {
                    console.log({ response });
                    reset();
                    setStartDate(new Date());

                },
                onError: (error) => {
                    console.log(error);
                }
            }
        );
    }

    return (
        <div className="form_container">
            <div className="form_area pt-10 pb-10 w-1/2  gap-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h1 className="text-center pb-6 font-extrabold">Create Batch</h1>
                    <div className="flex gap-x-24 items-start pb-3 ">
                        <label className="text-left w-32 pt-3">Name <span className="required-asterisk">*</span></label>
                        <input className="custom-inset-shadow  border border-gray-300 px-4 py-2 rounded-md flex-grow " {...register("Name")} />
                    </div>
                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">Plate Type <span className="required-asterisk">*</span></label>
                        <SelectDropDown className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow" {...register("Plate Type", { required: true })} options={PlateType} name="Plate Type" />
                    </div>

                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">Creation Date <span className="required-asterisk">*</span></label>
                        <div className="flex-grow">
                            <DatePicker className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md w-full" selected={startDate} onChange={(date) => setStartDate(date)} />
                        </div>
                    </div>

                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">DG Method <span className="required-asterisk">*</span></label>
                        <SelectDropDown className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow"{...register("DG Method", { required: true })} options={DGMethod} name="DG Method" />
                    </div>

                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">Maker <span className="required-asterisk">*</span></label>
                        <input className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow" {...register("Maker", { required: true })} />
                    </div>

                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">Quantity <span className="required-asterisk">*</span></label>
                        <input className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow" inputMode="numeric" {...register("Quantity", { required: true, pattern: /^[0-9]*$/ })} />

                    </div>

                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">FAM HI Size (μm)</label>
                        <input className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow" {...register("FAM HI Size (μm)")} />
                    </div>

                    <div className="flex gap-x-24 pb-3">

                        <label className="text-left w-32 pt-3">VIC HI Size (μm)</label>
                        <input className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow" {...register("VIC HI Size (μm)")} />
                    </div>

                    <div className="flex gap-x-24 pb-3">

                        <label className="text-left w-32 pt-3">HEX HI Size (μm)</label>
                        <input className="custom-inset-shadow border border-gray-300 px-4 py-2 rounded-md flex-grow" {...register("HEX HI Size (μm)")} />
                    </div>

                    <div className="flex gap-x-24 pb-3">
                        <label className="text-left w-32 pt-3">Notes</label>
                        <textarea className="border border-gray-300 px-4 py-2 rounded-md flex-grow"{...register("Notes")} />
                    </div>

                    <div className="button-group">
                        <button className={`text-white px-4 py-2 rounded flex justify-center items-center shadow-md ${formState.isDirty && formState.isValid ? "bg-green-700" : 'bg-gray-400 cursor-not-allowed'}`} type="submit" disabled={!(formState.isDirty && formState.isValid)}>Create Batch</button>
                        <button className="text-black px-4 py-2 flex justify-center items-center" type="reset">Cancel</button>
                    </div>
                    {createBatchMutation.isLoading &&
                        <div className="backdrop center-child">
                            <Spinner text="Creating Batch.." />
                        </div>
                    }
                </form>
            </div>
        </div>
    );



};

export default CreateBatch;